import { VideoModal } from './video_modal';

export class Video extends DrupalBehavior {
  onContent(context) {
    const videoModal = new VideoModal();
    const videos = context.querySelectorAll('.video-wrapper');
    videoModal.init(videos);
  }
}
DrupalBehavior.register('rush_theme.components', 'video', Video);
